// extracted by mini-css-extract-plugin
export default {"fullHeight":"SecondScreenNote_fullHeight__wWzbU","slideMenu":"SecondScreenNote_slideMenu__HamEJ"};